<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        PDV - Minhas Solicitações
    </h1>
    <div class="col-sm-12 col-md-5 col-xl-5 px-1">
        <a type="button" [routerLink]="['/pdv']"
            class="btn btn-outline-primary btn-outline-primary-historico float-right">
            <span>Voltar</span>
        </a>
    </div>
</header>
<ng-template #showLoading>
    <spinner [show]="true"></spinner>
</ng-template>
<ng-template #naoPossuiSolicitacoes>
    <p class="col-12 ng-template-text">
        Você não possui Solicitações do Programa de Demissão Voluntária!
    </p>
</ng-template>
<main class="col-12 main__content" *ngIf="!loading else showLoading">
    <blockquote class="mt-2 main-content-blockquote">
        Verifique sua(s) solicitação(es)
    </blockquote>
    <section *ngIf="listaSolicitacoes && listaSolicitacoes.length > 0; else naoPossuiSolicitacoes">
        <section class="content__header__table">
            <div class="col-xl-3">Benefício Solicitado</div>
            <div class="col-xl-3">Data da Solicitação</div>
            <div class="col-xl-3">Protocolo</div>
            <div class="col-xl-2">Status</div>
            <div class="col-xl-1">Ações</div>
        </section>
        <section class="content__main__table">
            <div class="table__card" *ngFor="let solicitacao of listaSolicitacoes; let i = index">
                <div class="col-xl-3">{{ solicitacao.benefitType?.description }}</div>
                <div class="col-xl-3">{{ solicitacao.solicitation.requestDate | date:'dd/MM/yyyy - HH:mm' || ' - ' }}
                </div>
                <div class="col-xl-3">{{ solicitacao.solicitation.ansProtocol }}</div>
                <div class="col-xl-2">
                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 10" />
                        <circle cx="10" cy="10" r="4" [attr.fill]="getRefundStatusColor(solicitacao.statusId)" />
                    </svg>
                    {{solicitacao.status.description}}
                </div>
                <div class="col-xl-1 content-buttons">
                    <a (click)="visualizardetalhes(solicitacao)">
                        <fa-icon class="fa-icon icon-eye" [icon]="faEye"></fa-icon>
                    </a>
                    <a (click)="downloadPdf(solicitacao)">
                        <fa-icon class="fa-icon icon-eye" [icon]="faPdf"></fa-icon>
                    </a>
                    <a (click)="cancelarSolicitacao(solicitacao)"
                        *ngIf="solicitacao.status?.description != 'Cancelado' ">
                        <fa-icon class="fa-icon fa-icon-trash icon-eye" [icon]="faTrash"></fa-icon>
                    </a>
                </div>
            </div>
        </section>
    </section>
</main>